import React from "react";
import { useSelector } from "react-redux";
import FDIncentivesStructure from "../../components/incentive-system/fd-incentives/FDIncentivesStructure";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";

const FDIncentives = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: FD Incentives">
      <FDIncentivesStructure userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default FDIncentives;